import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import { useFormikContext } from 'formik';

export interface submitButtonProps extends ButtonProps {
  alwaysEnabled?: boolean;
}

export const SubmitButton = ({
  alwaysEnabled,
  ...props
}: submitButtonProps) => {
  const { isSubmitting, isValid } = useFormikContext();

  const disabled = !alwaysEnabled && !isValid;

  if (isSubmitting) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress size="large" />
      </Box>
    );
  }

  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth
      type="submit"
      size="large"
      disabled={disabled}
      {...props}
    >
      {props.children}
    </Button>
  );
};
